//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["part","equipment"],"CreateEquipmentBuilder",{R_:{builder:"PID.EquipmentBuilder"}},2,0],[["part","portEquipment"],"CreatePortEquipmentBuilder",{R_:{builder:"PID.PortEquipmentBuilder"}},2,0],[["part","pipe"],"CreatePipeBuilder",{R_:{builder:"PID.PipeBuilder"}},2,0],[["part","oscObject"],"CreateOffSheetConnectorBuilder",{R_:{builder:"PID.OffSheetConnectorBuilder"}},2,0],[["part"],"CreateNativeSheet",{R_:{nativeSheet:"PID.NativeSheet"}},1,0]],[["NativeSheets","PID.NativeSheetCollection",0],["NativeEquipmentBuilder","PID.NativeEquipmentBuilder",0],["NativePortEquipmentBuilder","PID.NativePortEquipmentBuilder",0],["NativePipeBuilder","PID.NativePipeBuilder",0],["NativeOffSheetConnectorBuilder","PID.NativeOffSheetConnectorBuilder",0],["NativeFlowDirectionArrowBuilder","PID.NativeFlowDirectionArrowBuilder",0]]];
SPLM.PID.NativeManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.NativeManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;